<template>
  <div class="mail_box">
    <section class="no_padding">
      <h2>
        <v-icon color="mail_box_headline_font">mdi-message-question-outline</v-icon>
        サポートBOX
      </h2>

      <template v-if="supportBox.length > 0">
        <div v-for="(entry, index) in supportBox" :key="index" class="mail_box_list">
          <div @click="goDetail(entry.support_id)">
            <div class="mail_box_list_title">
              <div class="mail_box_list_actor">
                <v-icon color="mail_box_headline_font">mdi-face-agent</v-icon>
                <span>{{ entry.name }}</span>
              </div>
            </div>
            <div class="mail_box_list_text">
              <span v-if="entry.is_read" class="mail_box_list_body">{{ entry.latest_message }}</span>
              <span v-else><span class="badge"></span>新着メッセージがあります</span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <p class="text_center mail_box_empty">お問い合わせはありません。</p>
      </template>
    </section>
    <section class="text_center">
      <ul v-if="supportBox !== null" class="pagination pl-0">
        <li
          v-if="isPrev"
          class="prev link_main--text text-decoration-underline"
        ><span @click="goPagination('prev')">前へ</span></li>
        <li
          v-if="isNext"
          class="next link_main--text text-decoration-underline"
        ><span @click="goPagination('next')">次へ</span></li>
      </ul>
      <p>
        <router-link to="/" class="arrow link_main--text">トップページへ戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'SupportBox',
  data () {
    return {
      page: this.$route.query.page || 0,
      currentPage: null,
      total: null,
      perPage: null,
      supportBox: []
    }
  },
  computed: {
    isPrev () {
      return (this.currentPage > 1)
    },
    isNext () {
      return (this.currentPage < this.pageCount)
    },
    pageCount () {
      return Math.ceil(this.total / this.perPage)
    }
  },
  methods: {
    getList () {
      this.$store.dispatch('getSupportBoxList', {
        params: {
          page: this.page
        }
      })
        .then((data) => {
          this.supportBox = data.inquiries
          this.currentPage = data.current_page
          this.total = data.total
          this.perPage = data.per_page
        }).catch(err => {
          console.error(err)
        })
    },
    goPagination (type) {
      const nextPage = (type === 'prev') ? this.currentPage - 1 : this.currentPage + 1
      const params = Vue.util.extend({}, this.$route.params)
      const query = Vue.util.extend({}, this.$route.query)
      query.page = String(nextPage)
      this.page = nextPage
      this.$router.pushIsses({ name: this.component, params: params, query: query })
    },
    goDetail (id) {
      this.$router.pushIsses({ name: 'SupportBoxDetail', params: { id: id } })
    }
  },
  watch: {
    page: function () {
      this.currentPage = this.total = this.perPage = 0
      this.supportBox = []

      this.getList()
    }
  },
  created () {
    this.getList()
  }
}
</script>
